import Link from "next/link";

import { buildCategoryUrl } from "~/utils/route";

const STYLE_MAPPINGS = {
  talk: {
    backgroundColor: "#87C6B3",
    color: "#FFFFFF",
  },
  share: {
    backgroundColor: "#e7f3f0",
    color: "#91cbba",
  },
  faq: {
    backgroundColor: "#fde9e8",
    color: "#F3938E",
  },
  story: {
    backgroundColor: "#d8edff",
    color: "#1890FF",
  },
  jd: {
    backgroundColor: "#fdefcf",
    color: "#FFAE0E",
  },
  new: {
    backgroundColor: "#D9D7F1",
    color: "#3D087B",
  },
  talent: {
    backgroundColor: "#f9ba48",
    color: "#FFFFFF",
  },
  cv: {
    backgroundColor: "#F19794",
    color: "#FFFFFF",
  },
  normal: {
    backgroundColor: "#F5F3E7",
    color: "#877D6A",
  },
};

// helpers
const codeToStyle = (code) => {
  return STYLE_MAPPINGS[code] || STYLE_MAPPINGS.normal;
};

export default (props) => {
  const url = buildCategoryUrl(props.category.id);
  return (
    <Link href={url.href} as={url.as}>
      <a
        className={`category-link ${props.className}`}
        style={codeToStyle(props.category.code)}
      >
        {props.category.name}
        {props.tags &&
          props.tags.map((tag) => {
            if (
              props.category.code === "jd" &&
              tag.tag_group.code === "job_type"
            ) {
              return `·${tag.name}`;
            }
          })}
      </a>
    </Link>
  );
};
